import saveAs from 'file-saver';

import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import {
  DestinyItem,
  PricesItem,
  RequestItem,
  RequestPricesParams,
  RequestStatus,
  StatusChangeData,
  StatusItem,
} from '../types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getRequest: builder.query<RequestItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/Request/${data.id}`,
      }),
    }),
    getPrices: builder.query<PricesItem[], RequestPricesParams>({
      query: (params) => ({
        url: '/v1/Request/price',
        params,
      }),
    }),
    getRequestStatuses: builder.query<RequestStatus[], void>({
      query: () => ({
        url: '/v1/Request/Statuses',
      }),
    }),
    getRequestDestiny: builder.query<DestinyItem[], void>({
      query: () => ({
        url: '/v1/Request/Destiny',
      }),
    }),
    getRequestHistory: builder.query<any, PayloadRequest>({
      query: ({ id: requestId }) => ({
        url: `/v1/Request/${requestId}/history`,
      }),
    }),
    getRequestStatus: builder.query<StatusItem[], PayloadRequest>({
      query: (data) => ({
        url: `/v1/Request/${data.id}/status`,
      }),
    }),
    changeRequestStatus: builder.mutation<void, StatusChangeData>({
      query: (data) => ({
        url: `/v1/Request/${data.id}/status`,
        method: 'PUT',
        body: data,
      }),
    }),
    getDispatcherExcelReport: builder.query<void, string | null>({
      query: (params) => ({
        url: `/v1/request/dispatcherExcelReport?&filter=${params}`,
        responseHandler: async (response) => {
          saveAs(new Blob([await response.blob()], { type: 'application/octet-stream' }), 'report.xlsx');
        },
      }),
    }),
    createRequest: builder.mutation<void, RequestItem>({
      query: (data) => ({
        url: '/v1/Request',
        method: 'POST',
        body: data,
      }),
    }),
    changeRequest: builder.mutation<void, RequestItem>({
      query: (data) => ({
        url: `/v1/Request/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    getPaymentMethodReport: builder.query<void, string>({
      query: (params) => ({
        url: `/v1/Request/paymentMethodReport?filter=${params}`,
        responseHandler: async (response) => {
          saveAs(new Blob([await response.blob()], { type: 'application/octet-stream' }), 'report-arch.xlsx');
        },
      }),
    }),
    getArchiveRequestWorkExcelReport: builder.query<void, string>({
      query: (params) => ({
        url: `/v1/Request/archiveRequestWorkExcelReport?filter=${params}`,
        responseHandler: async (response) => {
          saveAs(new Blob([await response.blob()], { type: 'application/octet-stream' }), 'Отчет по отгрузкам.xlsx');
        },
      }),
    }),
  }),
});

export const {
  useGetRequestQuery,
  useLazyGetDispatcherExcelReportQuery,
  useLazyGetPricesQuery,
  useLazyGetRequestQuery,
  useLazyGetRequestStatusQuery,
  useGetRequestStatusQuery,
  useChangeRequestStatusMutation,
  useLazyGetRequestHistoryQuery,
  useCreateRequestMutation,
  useChangeRequestMutation,
  useLazyGetRequestDestinyQuery,
  useGetRequestDestinyQuery,
  useGetRequestStatusesQuery,
  useLazyGetPaymentMethodReportQuery,
  useLazyGetArchiveRequestWorkExcelReportQuery,
} = request;
